import { Component, Input, OnInit } from '@angular/core';
import { IAppState } from '../../../app/app.reducer';
import { Store } from '@ngrx/store';
import { selectBrandingConfiguration } from '../../app-configuration/app-configuration.reducer';
import { BrandingConfiguration } from '../../app-configuration/models/BrandingConfiguration';

@Component({
  selector: 'app-branding-logo-display',
  standalone: true,
  imports: [],
  templateUrl: './branding-logo-display.component.html',
  styleUrl: './branding-logo-display.component.scss'
})
export class BrandingLogoDisplayComponent implements OnInit {

  @Input()
  useDefaultLogo = false;

  brandingConfiguration?: BrandingConfiguration;

  constructor(private store$: Store<IAppState>) { }

  ngOnInit(): void {
    this.store$.select(selectBrandingConfiguration).subscribe((brandingConfiguration) => {
      this.brandingConfiguration = brandingConfiguration;
    });
  }

  getAssetPath() {
    if (this.useDefaultLogo) {
      return `${this.brandingConfiguration?.defaultLogoPath}`;
    } else {
      return `${this.brandingConfiguration?.logoPath}`;
    }
  }
}
